import '@styles/components/appBannerqlsj.less';
//import history from '@tools/history';
import { setTryOutDialog } from '@store/appSlice';
import { useAppDispatch } from '@hooks/reduxHooks';

const AppBannerqlsj = () => {
  const dispatch = useAppDispatch();

  return (
    <div className={'app-banner'}>
      <img className={'banner-bg'} src={require('@images/common/qldsBg.png').default} alt="" />
      <div className={'content'}>
        <div className={'logo'}>
          <img src={require('@images/common/qlds.png').default} alt="" />
        </div>
        <div className={'title'}>
          <span>桥梁大师</span>
        </div>
        <div className={'desc'}>二维CAD桥梁设计出图软件 </div>
        <div className={'theme'}>
          <img src={require('@images/common/qldsTheme.png').default} alt="" />
          <span>桥梁大师</span>
          <p>2023</p>
        </div>
        <div className={'operate'}>
          <span className={'free-qlds'} onClick={() => dispatch(setTryOutDialog(true))}>
            申请试用
          </span>
          {/* <span className={'buy'} onClick={() => history.push('/buy')}>
            立即购买
          </span> */}
        </div>
      </div>
    </div>
  );
};

export default AppBannerqlsj;
